/**
 * @ngDoc: btsCoupling
 * @description: 'EXPERIMENTAL Directive To handle hooking up AEM to NG through attributes and content.'
 */
module.exports = function (btsUi) {
    btsUi.directive('bcbsSubMenu', ['ViewRulesEngineFactory', '$state', '$timeout', '$window', '$compile', 'services', '$cookies', '$location', function (ViewRulesEngineFactory, $state, $timeout, $window, $compile, services, $cookies, $location) {
        var setupSubMenuNode = false;
        return {
            link: function (scope, element, attrs) {
                placeElement = function(event) {
                    $timeout(function () {
                    var bcbsSubMenu = angular.element('.sub-nav-container');
                    var parentNode = element.parent();
                    if (scope && scope.$root && scope.$root.isMobileNew) {
                        setupSubMenuNode = false;
                    }
                    if (scope && scope.$root && !scope.$root.isMobileNew) {
                        var existingNode = bcbsSubMenu.find('[data-bcbs-sub-menu="' + attrs['bcbsSubMenu'] + '"]');
                        if (existingNode.length === 0) {
                            bcbsSubMenu.prepend(element);
                        }
                    }

                        var headerTabs = angular.element('.headerTab .main-nav-item').not('.ng-hide');
                        var string = $location.absUrl();
                        var substring = "/member/home";
                        if(string.indexOf(substring)>-1){
                            if(headerTabs[2] && headerTabs[2].classList && headerTabs[2].classList.length == 3 ) {
                                headerTabs[2].classList.remove("defaultColorAdd");
                            }
                            headerTabs[2].className += " defaultColorAdd";
                            if(headerTabs[2] && headerTabs[2].children[0]){
                                headerTabs[2].children[0].setAttribute("aria-disabled", "true");
                                headerTabs[2].children[0].setAttribute("tabIndex", "-1");
                            }

                            services.rbsmbl.memberInfo().fetch().then(function (response) {
                                var container = document.querySelector(".sub-nav-container");
                                var matches = container.querySelectorAll(".main-nav-item");
                                var string1 = $location.absUrl();
                                var substring1 = "/member/home";
                                if(string1.indexOf(substring1)>-1){
                                    showActivePlanSubNav(matches, response.data.payload);
                                }
                            });
                            var showActivePlanSubNav = function(elementList,memberData){
                                var currentSelectedGroup = $cookies.get('mbrGroupNumber');
                                scope.showMedicalPlanText = false;
                                scope.showDentalPlanText = false;
                                scope.showVisionPlanText = false;
                                var currentClient;
                                var currentGroup;
                                for (var iClientIndex = 0; iClientIndex < memberData.clientList.length; ++iClientIndex) {
                                    currentClient = memberData.clientList[iClientIndex];
                                    for (var iGroupIndex = 0; iGroupIndex < currentClient.groupList.length; ++iGroupIndex) {
                                        currentGroup = currentClient.groupList[iGroupIndex];
                                        if(currentGroup.groupNumber == currentSelectedGroup) {
                                            if(currentGroup.productList[0].benefitPlanType == "Medical" || memberData.userName == "SDUID4100" || memberData.userName == "SDUID4101" || memberData.userName == "SDUID4102" || memberData.userName == "SDUID4103" || memberData.userName == "SDUID4104" || memberData.userName == "SDUID4105" || memberData.userName == "SDUID4106" || memberData.userName == "SDUID4107"){
                                                scope.showMedicalPlanText = true;
                                                scope.showDentalPlanText = false;
                                                scope.showVisionPlanText = false;
                                                var i;
                                                for(i=0; i<elementList.length; i++){
                                                    elementList[i].classList.remove("active-link");
                                                }
                                                if(elementList.length == "4"){
                                                    elementList[0].className += " active-link";
                                                }
                                                else if(elementList.length == "1"){
                                                    elementList[0].className += " active-link";
                                                }
                                            }
                                            else if(currentGroup.productList[0].benefitPlanType == "Vision"){
                                                scope.showMedicalPlanText = false;
                                                scope.showDentalPlanText = false;
                                                scope.showVisionPlanText = true;
                                                for(var i=0; i<elementList.length; i++){
                                                    elementList[i].classList.remove("active-link");
                                                }
                                                if(elementList.length == "4"){
                                                    elementList[2].className += " active-link";
                                                }
                                                else if(elementList.length == "1"){
                                                    elementList[0].className += " active-link";
                                                }
                                            }
                                            else if(currentGroup.productList[0].benefitPlanType == "Dental"){
                                                scope.showMedicalPlanText = false;
                                                scope.showDentalPlanText = true;
                                                scope.showVisionPlanText = false;
                                                for(var i=0; i<elementList.length; i++){
                                                    elementList[i].classList.remove("active-link");
                                                }
                                                if(elementList.length == "4"){
                                                    elementList[1].className += " active-link";
                                                }
                                                else if(elementList.length == "1"){
                                                    elementList[0].className += " active-link";
                                                }
                                            }
                                        }
                                    }
                                }
                            };
                        }
                        headerTabs.last().addClass('last-tab');

                        if (angular.element('[data-tab-parent=' + attrs.bcbsSubMenu + ']').length === 0) {
                            angular.element('.link-arrow').remove();
                            var arrow = angular.element('<div class="link-arrow" data-tab-parent="' + attrs.bcbsSubMenu + '">&nbsp;</div>');
                            //var activeLink = angular.element('.main-nav').find('.active-link');
                            if (parentNode[0]) {
                                var left = parentNode.offset().left + (parentNode.width() / 2) - 10;
                                var top = bcbsSubMenu.offset().top;
                                arrow.css({left: left, top: top - 5});
                                bcbsSubMenu.append(arrow);
                            }
                        }
                        else{
                            angular.element('.link-arrow').remove();
                            var arrow = angular.element('<div class="link-arrow" data-tab-parent="' + attrs.bcbsSubMenu + '">&nbsp;</div>');
                            //var activeLink = angular.element('.main-nav').find('.active-link');
                            if (parentNode[0]) {
                                var left = parentNode.offset().left + (parentNode.width() / 2) - 10;
                                var top = bcbsSubMenu.offset().top;
                                arrow.css({left: left, top: top - 5});
                                bcbsSubMenu.append(arrow);
                            }
                        }
                        if($window.innerWidth > 1023){
                            var tempNode = angular.element('.sub-nav-item');
                            if (tempNode.length > 1) {
                                tempNode[0].style.display = "none";
                            }
                        }
                    },100);
                };

                var isDesktop = true;
                $window.addEventListener('resize', function () {
                    //console.log($window.innerWidth, oldWidth);
                    if ($window.innerWidth > 1023 && !isDesktop) {
                        placeElement();
                        isDesktop = true;
                    }
                    else if ($window.innerwidth < 1024 && isDesktop) {
                        placeElement();
                        isDesktop = false;
                    }

                });
                placeElement();
            }
        };
    }]);
    btsUi.directive('bcbsUtilityMenu', ['ViewRulesEngineFactory', '$state', '$timeout', '$window', function (ViewRulesEngineFactory, $state, $timeout, $window) {
        return {
            link: function (scope, element) {
                function placeElement(event) {

                    var bcbsSubMenu = angular.element('.nav-container');
                    if (scope && scope.$root && scope.$root.isMobileNew) {
                        bcbsSubMenu.append(element);
                    }
                }

                $window.addEventListener('resize', placeElement());
                placeElement();
            }
        };
    }]);
};